import React, { useEffect, useState } from "react";
import { getVideo } from "../Service/Api";
import LazyLoad from "react-lazyload";
import { Link } from 'react-router-dom'
import Breadcrumb from '../Component/Breadcrumb'
const VideoGallery = () => {
    const [data, setData] = useState([]);
    const [filterData, setFilteredData] = useState([]);
    const [selectedYear, setSelectedYear] = useState("All"); // Default to "All"
    const [yearRanges, setYearRanges] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            const galleryData = await getVideo();
            setData(galleryData);

            // Extract unique years
            const uniqueYears = Array.from(
                new Set(galleryData.flatMap((item) => {
                    if (item.date) {
                        const year = new Date(item.date).getFullYear(); // Extract only the year
                        console.log(year)
                        return [year];
                    } else {
                        return [];
                    }
                }))
            );

            // Remove the map function for generating year ranges
            const uniqueYearRanges = uniqueYears.map(year => {
                return `${year}`;
            });

            uniqueYearRanges.sort((a, b) => b - a);
            console.log("Unique Year Ranges:", uniqueYearRanges); // Log uniqueYearRanges
            setYearRanges(uniqueYearRanges);
        };
        fetchData();
    }, []);

    useEffect(() => {
        // Filter data based on selected year
        let filteredData = data;
        if (selectedYear !== "All") {
            filteredData = filteredData.filter((item) => {
                if (item.date) {
                    const year = new Date(item.date).getFullYear();
                    return parseInt(selectedYear) === year;
                } else {
                    return false;
                }
            });
        }
        setFilteredData(filteredData);
    }, [selectedYear, data]);

    return (
        <>
             <Breadcrumb breadtitle="Video Gallery" breadmid="Gallery" breadend="Video Gallery" />
            <section className="innerpage">
                <div className="container">
                    <div className="row inner_cont">
                        <div className="col-lg-12">
                            <div className="chooseyear">
                                <select id="chooseddlYear"
                                    value={selectedYear}
                                    onChange={(e) => setSelectedYear(e.target.value)}
                                    className="yearSelection"
                                >
                                    <option value={"All"}>All</option>
                                    {yearRanges.map((yr) => (
                                        <option key={yr} value={yr}>{yr}</option>
                                    ))}
                                </select>

                            </div> 
                            <div className="row">
                                {filterData.length > 0 ? filterData.map((item, index) => (
                                    <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 videosearch" key={index}>
                                        <div className="video-gallery">
                                            <Link to={item.videoUrl} target="_blank">
                                                <LazyLoad>      <img src="https://webapi.entab.info/api/image/CSFL/public/images/play.png" alt="Cannosa School Lucknow" className="img-fluid mx-auto d-block" /></LazyLoad>
                                                <h3>{item.title}</h3>
                                            </Link>
                                        </div>
                                    </div>
                                )):(<>
                                 <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 videosearch">
                                        <div className="video-gallery">
                                            <Link to="#" target="_blank">
                                                <LazyLoad><img src="https://webapi.entab.info/api/image/CSFL/public/images/play.png" alt="Cannosa School Lucknow" className="img-fluid mx-auto d-block" /></LazyLoad>
                                               <div> <h3>Video Title</h3>
                                               <p>DD.MM.YYYY</p>
                                               </div>
                                            </Link>
                                        </div>
                                    </div>
                                </>)}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default VideoGallery
